<div class="sidebar-outer">
    <a class="logo d-flex align-items-center"  (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
        <span class="start">YK</span><span class="ng">MART</span>
    </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>
